import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { categoriesAPI } from '../utils/api';

const ICONES = [
  { id: 'firewall', label: 'Firewall', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z"/><path d="M9 12l2 2 4-4"/></svg>' },
  { id: 'router', label: 'Routeur', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="8" width="20" height="8" rx="2"/><circle cx="6" cy="12" r="1" fill="currentColor"/><circle cx="10" cy="12" r="1" fill="currentColor"/><path d="M14 12h4"/><path d="M8 8V6a4 4 0 018 0v2"/><path d="M6 16v2M18 16v2"/></svg>' },
  { id: 'switch', label: 'Switch', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="9" width="20" height="6" rx="1"/><path d="M6 9V7M9 9V7M12 9V7M15 9V7M18 9V7"/><path d="M6 15v2M9 15v2M12 15v2M15 15v2M18 15v2"/><circle cx="19" cy="12" r="1" fill="currentColor"/></svg>' },
  { id: 'ap', label: 'Borne WiFi', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12.55a11 11 0 0114 0"/><path d="M1.42 9a16 16 0 0121.16 0"/><path d="M8.53 16.11a6 6 0 016.95 0"/><circle cx="12" cy="20" r="1" fill="currentColor"/></svg>' },
  { id: 'server', label: 'Serveur', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="5" rx="1"/><rect x="2" y="10" width="20" height="5" rx="1"/><rect x="2" y="17" width="20" height="4" rx="1"/><circle cx="6" cy="5.5" r="0.8" fill="currentColor"/><circle cx="6" cy="12.5" r="0.8" fill="currentColor"/><circle cx="6" cy="19" r="0.8" fill="currentColor"/></svg>' },
  { id: 'camera', label: 'Caméra', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>' },
  { id: 'nvr', label: 'Enregistreur', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="8" cy="12" r="2"/><path d="M14 10h4M14 14h4"/><circle cx="8" cy="12" r="1" fill="currentColor"/></svg>' },
  { id: 'cable', label: 'Câble', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 12h3l2-4 4 8 2-4h3"/><circle cx="2" cy="12" r="1" fill="currentColor"/><circle cx="22" cy="12" r="1" fill="currentColor"/></svg>' },
  { id: 'patch', label: 'Patch panel', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="8" width="20" height="8" rx="1"/><rect x="4" y="10" width="2" height="4" rx="0.5"/><rect x="8" y="10" width="2" height="4" rx="0.5"/><rect x="12" y="10" width="2" height="4" rx="0.5"/><rect x="16" y="10" width="2" height="4" rx="0.5"/><rect x="20" y="10" width="2" height="4" rx="0.5"/></svg>' },
  { id: 'ups', label: 'Onduleur', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M13 4v4h4l-6 12v-8H7l6-8z" fill="currentColor" stroke="none" opacity="0.7"/></svg>' },
  { id: 'rack', label: 'Baie rack', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="5" y="2" width="14" height="20" rx="1"/><rect x="7" y="5" width="10" height="2" rx="0.5"/><rect x="7" y="9" width="10" height="2" rx="0.5"/><rect x="7" y="13" width="10" height="2" rx="0.5"/><rect x="7" y="17" width="10" height="2" rx="0.5"/><circle cx="15" cy="6" r="0.5" fill="currentColor"/><circle cx="15" cy="10" r="0.5" fill="currentColor"/></svg>' },
  { id: 'phone', label: 'Téléphone IP', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 7h6M9 11h6M9 15h2"/><rect x="13" y="14" width="3" height="4" rx="0.5"/></svg>' },
  { id: 'repeater', label: 'Répéteur', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="3"/><path d="M6.3 6.3a8 8 0 000 11.4"/><path d="M17.7 6.3a8 8 0 010 11.4"/><path d="M3.5 3.5a12.5 12.5 0 000 17"/><path d="M20.5 3.5a12.5 12.5 0 010 17"/></svg>' },
  { id: 'modem', label: 'Modem', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="10" width="20" height="8" rx="2"/><path d="M8 10V8a4 4 0 018 0v2"/><circle cx="8" cy="14" r="1" fill="currentColor"/><circle cx="12" cy="14" r="1" fill="currentColor"/><circle cx="16" cy="14" r="1" fill="currentColor"/></svg>' },
  { id: 'printer', label: 'Imprimante', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="8"/><circle cx="18" cy="11.5" r="0.5" fill="currentColor"/></svg>' },
  { id: 'hdd', label: 'Disque dur', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><ellipse cx="12" cy="12" rx="10" ry="6"/><path d="M2 12v4c0 3.31 4.48 6 10 6s10-2.69 10-6v-4"/><circle cx="16" cy="12" r="1" fill="currentColor"/><path d="M6 12h6"/></svg>' },
  { id: 'dock', label: 'Docking', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="14" width="18" height="4" rx="1"/><path d="M8 14v-4h8v4"/><path d="M7 18v2M17 18v2"/><rect x="6" y="6" width="12" height="8" rx="1"/></svg>' },
  { id: 'media', label: 'Convertisseur', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="8" width="8" height="8" rx="1"/><rect x="14" y="8" width="8" height="8" rx="1"/><path d="M10 12h4M13 10l2 2-2 2"/></svg>' },
  { id: 'box', label: 'Autre', svg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>' },
];

const COULEURS = ['#3b82f6','#10b981','#f59e0b','#ef4444','#8b5cf6','#e8192c','#06b6d4','#f97316','#6366f1','#14b8a6'];
const EMPTY = { nom: '', icone: 'box', couleur: '#3b82f6', description: '' };

function IcnSvg({ id, size = 22, color = 'currentColor' }) {
  const found = ICONES.find(i => i.id === id) || ICONES.find(i => i.id === 'box');
  return (
    <span style={{ display: 'inline-flex', width: size, height: size, color }}
      dangerouslySetInnerHTML={{ __html: found.svg }} />
  );
}

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [current, setCurrent] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => {
    setLoading(true);
    categoriesAPI.getAll().then(r => setCategories(r.data)).finally(() => setLoading(false));
  };

  useEffect(load, []);

  const openCreate = () => { setForm(EMPTY); setCurrent(null); setModal('form'); };
  const openEdit = (c) => { setForm({ ...c }); setCurrent(c); setModal('form'); };

  const handleSave = async () => {
    setSaving(true);
    try {
      if (current) {
        await categoriesAPI.update(current._id, form);
        toast.success('Catégorie mise à jour');
      } else {
        await categoriesAPI.create(form);
        toast.success('Catégorie créée');
      }
      setModal(null); load();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Erreur');
    } finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette catégorie ?')) return;
    await categoriesAPI.delete(id);
    toast.success('Supprimée');
    load();
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <div className="page-title">Catégories</div>
          <div className="page-subtitle">Classification des équipements réseau</div>
        </div>
        <button className="btn btn-primary" onClick={openCreate}>+ Ajouter</button>
      </div>

      {loading ? (
        <div className="loading"><div className="spinner"></div>Chargement...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 14 }}>
          {categories.map(c => (
            <div key={c._id} style={{
              background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10,
              padding: '18px 16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
              borderTop: `3px solid ${c.couleur || '#3b82f6'}`,
              transition: 'box-shadow 0.15s',
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 12 }}>
                <div style={{
                  width: 44, height: 44, borderRadius: 10,
                  background: `${c.couleur || '#3b82f6'}15`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <IcnSvg id={c.icone} size={24} color={c.couleur || '#3b82f6'} />
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                  <button className="btn btn-sm btn-outline" onClick={() => openEdit(c)} style={{ padding: '4px 8px' }}>✎</button>
                  <button className="btn btn-sm btn-danger" onClick={() => handleDelete(c._id)} style={{ padding: '4px 8px' }}>✕</button>
                </div>
              </div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#1a1f2e', marginBottom: 4 }}>{c.nom}</div>
              {c.description && <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.4 }}>{c.description}</div>}
            </div>
          ))}
          {categories.length === 0 && (
            <div className="empty-state" style={{ gridColumn: '1/-1' }}>
              <div className="empty-icon">🗂</div>Aucune catégorie. Commencez par en créer une.
            </div>
          )}
        </div>
      )}

      {modal === 'form' && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div className="modal" style={{ maxWidth: 520 }}>
            <div className="modal-header">
              <span className="modal-title">{current ? 'Modifier la catégorie' : 'Nouvelle catégorie'}</span>
              <button className="btn btn-sm btn-danger btn-icon" onClick={() => setModal(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
                <div className="form-group">
                  <label className="form-label">Nom *</label>
                  <input className="input" value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} placeholder="Ex: Firewall, Switch, Caméra..." />
                </div>

                <div className="form-group">
                  <label className="form-label">Icône</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(56px, 1fr))', gap: 6, marginTop: 4 }}>
                    {ICONES.map(i => (
                      <button key={i.id} onClick={() => setForm(f => ({ ...f, icone: i.id }))}
                        title={i.label}
                        style={{
                          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
                          padding: '8px 4px', borderRadius: 8, cursor: 'pointer',
                          border: form.icone === i.id ? `2px solid ${form.couleur}` : '1px solid #e5e7eb',
                          background: form.icone === i.id ? `${form.couleur}10` : '#fafafa',
                          transition: 'all 0.1s',
                        }}>
                        <span style={{ display: 'inline-flex', width: 20, height: 20, color: form.icone === i.id ? form.couleur : '#6b7280' }}
                          dangerouslySetInnerHTML={{ __html: i.svg }} />
                        <span style={{ fontSize: 9, color: '#9ca3af', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 48 }}>{i.label}</span>
                      </button>
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Couleur</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 4 }}>
                    {COULEURS.map(col => (
                      <button key={col} onClick={() => setForm(f => ({ ...f, couleur: col }))}
                        style={{
                          width: 28, height: 28, borderRadius: '50%', cursor: 'pointer',
                          background: col, border: form.couleur === col ? `3px solid ${col}` : '2px solid transparent',
                          outline: form.couleur === col ? '2px solid white' : 'none',
                          outlineOffset: '-4px',
                          boxShadow: form.couleur === col ? `0 0 0 3px ${col}44` : 'none',
                        }} />
                    ))}
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label">Description</label>
                  <input className="input" value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="Description optionnelle" />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={() => setModal(null)}>Annuler</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? '...' : 'Enregistrer'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}